<template>
	<div class="wrapper-content fadeInRight animated tabBox" id="directiveList">
		<div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
			<!--表单查询开始-->
			<div class="form-horizontal" id="search">
				<div class="form-group">
					<label class="col-sm-1 control-label">指令名称</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParam.cmdName" maxlength="20">
					</div>
					<label class="col-sm-1 control-label">指令类型</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.cmdType">
							<option v-for="(option, index) in cmdTypes" v-bind:value="option.udccode" :key="'cmdType' + index">
								{{ option.udcname }}
							</option>
						</select>
					</div>
				</div>

				<div class="form-group ">
					<div class="col-sm-12 text-right">
						<button class="btn btn-primary" @click="resetQueryParams">重置</button>
						<button class="btn btn-primary" @click="searchInfo">查询</button>

					</div>
					<div class="col-sm-12 text-left">
						<button class="btn btn-primary" @click="createNew()">添加新指令</button>
					</div>
				</div>

				<div class="hr-line-dashed"></div>
			</div>
			<!--表单查询结束-->
			<!--表格开始-->
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover fixedTable module_table">
					<thead>
						<tr role="row">
							<th width="5%"></th>
							<th width="5%">序号</th>
							<th>指令名称</th>
							<th>指令类型</th>
							<th>操作</th>
						</tr>
					</thead>
					<transition-group name="list-complete" tag="tbody">
						<tr v-for="(cmdInfo,index) in cmds" v-bind:key="index + 'cmdinfolist'" class="list-complete-item">
							<td class="hand text-center">
								<a v-show="cmdInfo.deviceCategoryCount==0" @click="remove(cmdInfo)"><i class="glyphicon glyphicon-trash"></i></a>
								<i v-show="cmdInfo.deviceCategoryCount>0" :title="'有'+cmdInfo.deviceCategoryCount+'种设备类型使用此指令,请先解除关联再进行删除！'" class="glyphicon glyphicon-trash"></i>
							</td>
							<td class="hand text-center">{{index + 1}}</td>
							<td class="hand text-center">{{cmdInfo.cmdName}}</td>
							<td class="hand text-center">{{cmdInfo.cmdTypeName}}</td>
							<td class="hand text-center">
								<a @click="edit(cmdInfo)">编辑</a>
								<a @click="check(cmdInfo)">查看</a>
							</td>
						</tr>
					</transition-group>
				</table>
			</div>
			<!--表格结束-->

			<!--分页组件开始-->
			<pagination v-if="cmds.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
			<!--分页组件结束-->

			<sub-page  :bigTitleMsg="subTitle" :scroll="scrollTop"  :show="subShow"  v-on:cancel="endEdit">
				<div slot="bodycontent">
					<page-device-directive-edit ref="editPanel" :cmdTypes="cmdTypes" :mode='editMode' v-on:toClose="endEdit"></page-device-directive-edit>
				</div>
			</sub-page>

			<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
				{{messageStr}}
				<div slot="footer">
					<button @click="closeModalMsg" class="btn btn-primary">确定</button>
				</div>
			</tab-modal>

			<!--   弹出框子组件2        -->
			<tab-modal ref="modal2" size="small" title="提示" :scroll='scrollTop' v-on:cancel="closeModal('modal2')">
				确定删除该指令？
				<div slot="footer">
					<button @click="closeModal('modal2')" class="btn btn-primary">取消</button>
					<button @click="removeC()" class="btn btn-primary">确定</button>
				</div>
			</tab-modal>

		</div>
	</div>
</template>

</template>

<script>
	import Pagination from 'components/common/Pagination'
	import { DICTIONARY_MAP } from 'static/constant'
	import { getDictionaryFromArray } from 'util/util'
	import classlist from 'util/classlist'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import SubPage from 'components/common/SubPage'
	import TabModal from 'components/common/TabModal'
	import PageDeviceDirectiveEdit from 'components/pages/devicedirective/PageDeviceDirectiveEdit'

	export default {
	  name: 'PageDeviceDirectiveList',
	  components: {
	    Pagination,
	    SubPage,
	    TabModal,
	    PageDeviceDirectiveEdit
	  },
	  data () {
    return {
	      queryParam: {
	        cmdName: '',
	        cmdType: '',
	        page_index: 1
	      },
	      cmdTypes: [],
	      udcType: [
	        DICTIONARY_MAP.CMD_TYPE
	      ],
	      scrollTop: '', // 弹框top值
	      loadingstatus: false,
	      cmds: [],
	      messageStr: '',
	      pageInfo: {}, // 分页所需信息

	      editItem: {}, // 正在编辑的
	      editMode: '',
	      subShow: false,
	      subTitle: ''
	    }
  },
	  beforeMount () {
	    this.getUdc()
	    this.getCmds()
	  },
	  methods: {
	    getUdc () {
	      if (this.udcType.length == 0) return
	      let param = this.udcType.join(',')
	      this.$http.get(process.env.API_ROOT + '/system/udcs', { params: { udcTypes: param } })
					.then(res => {
	  if (res.data.success) {
	    this.cmdTypes = getDictionaryFromArray(res.data.data, DICTIONARY_MAP.CMD_TYPE)
	  } else {
	    this.openModalMsg(res.body.message)
	  }
	},
						res => {
	  this.openModalMsg(res.body.message)
	}
					)
					.catch(res => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	})
	    },
	    getCmds () {
	      this.loadingstatus = true
	      this.$http.get(process.env.API_ROOT + '/system/cmd', { params: this.queryParam })
					.then(res => {
	  if (res.data.success) {
	    const resInfo = res.body.data
	    const { pageNum, pages, total, isFirstPage, isLastPage } = resInfo
	    this.pageInfo = {
	      pageNum: pageNum,
	      pages: pages,
	      total: total,
	      isFirstPage: isFirstPage,
	      isLastPage: isLastPage
	    },
									this.cmds = res.data.data.list
	    this.loadingstatus = false
	  } else {
	    this.openModalMsg(res.body.message)
	    this.loadingstatus = false
	  }
	},
						res => {
	  this.openModalMsg(res.body.message)
	  this.loadingstatus = false
	}
					)
					.catch(res => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	  this.loadingstatus = false
	})
    },
	    remove (item) {
	      this.editItem = item
	      this.$refs.editPanel.setEditItem(item)
	      this.openModal('modal2')
	    },
	    removeC () {
	      this.closeModal('modal2')
	      let item = this.editItem
	      this.loadingstatus = true
	      this.$http.delete(process.env.API_ROOT + '/system/cmd/' + item.id)
					.then(res => {
	  if (res.data.success) {
	    this.loadingstatus = false
	    this.getCmds()
	  } else {
	    this.loadingstatus = false
	    this.openModalMsg(res.data.message)
	  }
	})
					.catch(res => {
	  this.openModalMsg(res.data.message)
	  this.loadingstatus = false
	})
	    },

	    edit (item) {
	      classlist.toggleScroll('close', '#directiveList', this)
	      this.editMode = 'edit'
	      this.subTitle = '指令编辑'
	      this.editItem = item
	      this.$refs.editPanel.setEditItem(this.editItem)

	      this.subShow = true
	    },
	    createNew () {
	      classlist.toggleScroll('close', '#directiveList', this)
	      this.subTitle = '指令新建'
	      this.editMode = 'create'
	      this.editItem = {}
	      this.editItem.cmdName = ''
	      this.editItem.cmdType = 0
	      this.editItem.createTime = ''
	      this.editItem.updateTime = ''
	      this.$refs.editPanel.setEditItem(this.editItem)
	      this.subShow = true
	    },

	    check (item) {
	      classlist.toggleScroll('close', '#directiveList', this)
	      this.editMode = 'check'
	      this.subTitle = '指令查看'
	      this.editItem = item
	      this.$refs.editPanel.setEditItem(this.editItem)
			// this.editItem = this.deepCopy(item);
	      this.subShow = true
	    },
	    endEdit (action) {
	      classlist.toggleScroll('open', '#directiveList', this)
	      this.subShow = false
	      if (action == 'refresh') { this.getCmds() }
	    },
	    searchInfo () {
	      this.getCmds()
	    },
	    getPageNo (param) {
	      this.queryParam.page_index = param
	      this.getCmds()
	    },

			// 重置信息
	    resetQueryParams () {
	      this.queryParam = {
	        cmdName: '',
	        cmdType: '',
	        page_index: 1
	      }
	    },

			// 深复制
	    deepCopy (source) {
	      var result = {}
	      for (var key in source) {
	        result[key] = typeof source[key] === 'object' ? this.deepCopy(source[key]) : source[key]
	      }
	      return result
	    },
			// 消息弹出框相关
	    openModal (ref) {
	      this.$refs[ref].open()
	      classlist.toggleScroll('close', '#directiveList', this)
	    },
	    closeModal (ref) {
	      this.$refs[ref].close()
	      classlist.toggleScroll('open', '#directiveList', this)
	    },
	    closeModalMsg () {
	      this.closeModal('modalMsg')
	    },
	    openModalMsg (message) {
	      this.messageStr = message
	      this.openModal('modalMsg')
	    }

	  }
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PageDeviceDirectiveList.vue?39b35c8f